import { Col, Row } from "@/components";
import "./WaitTimeTable.scss";

export interface WaitTimeTableData {
    color: string;
    label: string;
    time: number | string;
    waiting: number;
    treatment: number;
}

export interface WaitTimeTableProps {
    data: WaitTimeTableData[];
}

export const WaitTimeTable = ({
    data,
}: WaitTimeTableProps) => {
    return (
        <Col
            as={"article"}
            bg={"white"}
            br={"x4"}
            p={"x16"}
            gap={"x16"}
            className="shadow md-p-x24 md-gap-x24"
        >
            <Row as={"header"} gap={"x16"} className="align-items-center">
                <h3 className="fs-3 fw-bold text-slate-20">Tempi di attesa</h3>
            </Row>
            <div className="ui-wait-time-table-content">
                <table className="wait-time-table">
                    <thead>
                        <tr>
                            <th>Codice di accesso</th>
                            <th>Tempo di attesa</th>
                            <th>Pazienti in attesa</th>
                            <th>Pazienti in trattamento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row) => (
                            <tr key={row.color}>
                                <td>
                                    <div className="access-code-container">
                                        <div className={`color-indicator ${row.color}`} />
                                        <span>
                                            {row.label}
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    {row.time} minuti
                                </td>
                                <td>
                                    {row.waiting}{ " "}
                                    {row.waiting === 1 ? "paziente" : "pazienti"}
                                </td>
                                <td>
                                    {row.treatment}{" "}
                                    {row.treatment === 1 ? "paziente" : "pazienti"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Col>
    );
};
